import React, { FC, Dispatch, SetStateAction, Fragment } from 'react';
import classNames from 'classnames';
import styled from 'styled-components';

import { useTranslation } from '@crehana/i18n';

import { DegreeQuota } from 'Jsx/CheckoutV4/types';

import { CheckoutTKeys } from '../../i18n/language';

const LabelContainer = styled.input`
  &:checked + label {
    border-color: ${({ theme }) => theme.colors.primary.light};
  }
`;

interface QuotasSelectorProps {
  symbol: string | null;
  quotas?: DegreeQuota[];
  selectedQuotaNumber: number;
  setSelectedQuotaNumber: Dispatch<SetStateAction<number>>;
}

const QuotasSelector: FC<QuotasSelectorProps> = ({
  symbol,
  quotas,
  selectedQuotaNumber,
  setSelectedQuotaNumber,
}) => {
  const { t } = useTranslation<CheckoutTKeys>();
  const hasOnlyOneQuota =
    quotas && quotas.length === 1 && quotas[0]?.quotaNumber === 1;

  if (!quotas || hasOnlyOneQuota) return null;

  return (
    <div className="mb-40">
      <h3 className="font-subtitle1">{t('CHOOSE_QUOTA')}</h3>
      {quotas.map(({ quotaNumber, quotaAmount, interest }, index) => {
        const unique = `quota-${quotaNumber}`;

        return (
          <Fragment key={unique}>
            <LabelContainer
              className="hidden"
              id={unique}
              type="radio"
              name="quotaNumber"
              value={quotaNumber!}
              checked={selectedQuotaNumber === quotaNumber}
              onChange={() => setSelectedQuotaNumber(quotaNumber!)}
            />
            <label
              htmlFor={unique}
              className={classNames(
                'bg-white rounded-5 w-full flex justify-between px-16 sm:px-20 py-12 sm:py-16 items-center mt-16 border border-solid cursor-pointer border-gray-light',
                {
                  'mt-24': index !== 0,
                },
              )}
            >
              <div className="flex items-center">
                <span className="font-subtitle1-sm font-subtitle2">
                  x{quotaNumber}
                </span>
                <span className="font-subtitle1-sm font-subtitle2 ml-24 sm:ml-32">
                  {symbol} {quotaAmount?.toLocaleString('en-US')}
                </span>
              </div>
              {interest === 0 && quotaNumber && quotaNumber > 1 && (
                <span className="font-subtitle1-sm font-subtitle2 text-primary-light">
                  Sin intereses
                </span>
              )}
            </label>
          </Fragment>
        );
      })}
    </div>
  );
};

export default QuotasSelector;
